import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table, Params, Actions } from 'nallian-table-builder-ui';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import { INFINITE_SCROLL, ORGANISATION_COMMUNITIES_RESOURCE } from '../../constants';
import apiRoutes from '../../../../app/api/routes';

const COMMUNITY_RIGHTS = ['COMMUNITIES.MANAGE.ALL', 'COMMUNITIES.READ.ALL'];

const OrganisationCommunities = ({ organisationId }) => {
  const { t } = useTranslation();

  return (
    <>
      <Table
        infiniteScroll={INFINITE_SCROLL}
        resource={ORGANISATION_COMMUNITIES_RESOURCE}
        url={addParametersToUri(apiRoutes.getCommunities(), { organisationId })}
        noResultsMessage={t('noOrganisationCommunitiesFound')}
        pageSize={50}
        noUserSettings
        resizable
      >
        <Actions.Link
          label=" "
          icon="eye"
          width="2.5rem"
          align="center"
          name="id"
          url="/communities/:id"
          hasSomeRights={COMMUNITY_RIGHTS}
        />
        <Params.String name="name" width="20rem" minWidth="20rem" noFilter grow />
        <Params.String name="tag" width="20rem" minWidth="20rem" noFilter grow />
      </Table>
    </>
  );
};

OrganisationCommunities.propTypes = {
  organisationId: PropTypes.string.isRequired,
  urlRoot: PropTypes.string.isRequired,
  dispatchResendInvitationPut: PropTypes.func.isRequired,
  resendInvitationFetch: PropTypes.object.isRequired,
  forbidManageBecauseSystemOrg: PropTypes.bool.isRequired,
};

export default OrganisationCommunities;
